module.exports = __webpack_public_path__ + "static/1-e6f254ab5d822e41df3c6e7cf6b54f24.jpeg";